// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"constellation_wrapper___hmDF","body":"constellation_body__0ISMC","imageWrapper":"constellation_imageWrapper__y1nQn"};